import axios from 'axios';

export const state = () => ({});

export const getters = {};

export const mutations = {};

export const actions = {
    index(vuexContext, { page = 1, perPage = 10, searchParams = {} }) {
        return axios.$get('/admin/media', {
            params: {
                page,
                perPage,
                ...searchParams
            }
        });
    },

    show(vuexContext, id) {
        return axios.$get(`/admin/media/${id}`);
    },

    update(vuexContext, media) {
        return axios.$put(`/admin/media/${media.id}`, media);
    },

    delete(vuexContext, id) {
        return axios.$delete(`/admin/media/${id}`);
    },

    crop(vuexContext, { id, coordinates }) {
        return axios.$post(`/admin/media/${id}/crop`, { coordinates });
    }
};
